module.exports = __webpack_public_path__ + "static/media/sample_return_pallets.0a361a02.csv";